<template>
  <div
    id="eventDetails"
    class="modal fade show"
    data-bs-keyboard="false"
    data-bs-backdrop="static"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    style="display: block;"
    aria-modal="true"
    role="dialog"
  >
    <div
      class="mt-6 modal-dialog modal-lg"
      role="document"
    >
      <div class="border-0 modal-content">
        <div class="top-0 z-1 position-absolute me-3 mt-3 end-0">
          <button
            class="d-flex flex-center transition-base btn-close btn btn-sm btn-circle"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="handleClose"
          />
        </div>

        <div class="bg-body-tertiary py-3 ps-4 pe-6 rounded-top-3">
          <h4
            id="staticBackdropLabel"
            class="mb-1"
          >
            센서 설정
          </h4>
          <p class="mb-0 fs-11">
            센서 이름 : <a
              class="link-600 fw-semi-bold"
              href="#!"
            >{{ setsensor.sname }} ({{ setsensor.dfkey }}) </a>
          </p>
        </div>

        <div class="px-card pt-1 pb-card modal-body fs--1">
          <div class="mt-3 media">
            <div class="media-body">
              <div
                v-if="deviceConfig"
                class="text-800 fs--1"
              >
                <div class="d-flex align-items-center modal_div">
                  <h6 class="me-2 mb-0 device-title">
                    임계치 이탈 알림
                  </h6>
                  <input 
                    v-model="setGuageValue.alert" 
                    class="form-check-input"
                    type="checkbox" 
                  >

                  <input
                    id="input-setinterval"
                    v-model.number="setGuageValue.guage"
                    class="form-control"
                    type="number"
                    placeholder=""
                    style="width:60px"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a
            class="btn btn-falcon-default btn-sm"
            @click="handleSave"
          >
            <span
              class="mr-2 fs--2"
              data-fa-i2svg=""
            />저장
          </a>
          <a
            class="btn btn-falcon-default btn-sm"
            @click="handleClose"
          >
            <span
              class="mr-2 fs--2"
              data-fa-i2svg=""
            />취소
          </a>
        </div>
      </div>
    </div>
  </div>

  <AlertModal ref="alertModalRef" />
</template>

<script setup lang="ts">

import type { Device, DeviceConfig, AjaxResult, Sensor, DeviceSensorConfig} from '@/types/commontypes'
import { onMounted, ref, watch} from 'vue';
import AlertModal from "@/components/AlertModal.vue";

const emit = defineEmits(['close', 'save'])

const props = defineProps<{
    setdevice: Device;
    setsensor: Sensor;
}>();

const deviceConfig = ref<DeviceConfig>({} as DeviceConfig);
const setGuageValue = ref<DeviceSensorConfig>({} as DeviceSensorConfig);

const alertModalRef = ref();


const defaultDeviceConfig: DeviceConfig = {
      deviceid: '',
      regdt: '',
      config: '',
      configjson: {set_interval:0, set_gauge:0, set_sensor: {}},
      ucount: 0,
      configuse: 0,
      apply: 0,
      alertconfig: '',
      alertconfigjson: {
        alert: false,
        dataalert: false,
        regularalert: false,
        regularalertinterval: 0,
        regularalertstarttime: 0,
        regularalertendtime: 0,
        sendsms: false,
        recvlist: "",
      }
    }

onMounted(async () =>{
  initDevice();
});

watch(
  () => [props.setdevice],
  ([_newSetDev], [_oldSetDev]) => {
    initDevice();
  },
  { deep: true }
);

const initDevice = () => {
    // 초기화 작업 수행
    console.log('디바이스 세팅 팝업 초기화 작업 수행 :', props.setdevice);
    loadDeviceConfig();
}


function loadDeviceConfig() {
	// 입력값을 변수에 담고 문자열 형태로 변환
  const data = JSON.stringify({ 'operator': "loadDeviceConfig", 'deviceid' : props.setdevice.deviceid });
   
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', () => {
		let result = JSON.parse(xhr.responseText);

    if(result) {
      if(result.err === 0) {
          deviceConfig.value = result.data;
          deviceConfig.value.configjson = JSON.parse(deviceConfig.value.config);

          // Initialize set_sensor if it doesn't exist
          if (!deviceConfig.value.configjson.set_sensor) {
            deviceConfig.value.configjson.set_sensor = {};
          }
          if(!deviceConfig.value.configjson.set_sensor[props.setsensor.dfkey])
            deviceConfig.value.configjson.set_sensor[props.setsensor.dfkey] = {alert:false, guage:0}

          const alertconfig_temp = deviceConfig.value.alertconfig.replace(/[\r\n]+/g, '\\n');
          deviceConfig.value.alertconfigjson= JSON.parse(alertconfig_temp);

          const dConfig = deviceConfig.value.configjson;
          const sConfig = dConfig?.set_sensor?.[props.setsensor.dfkey]

          setGuageValue.value.guage = sConfig.guage
          setGuageValue.value.alert = sConfig.alert
        } else {
          deviceConfig.value = {...defaultDeviceConfig}
          deviceConfig.value.configjson = JSON.parse(deviceConfig.value.config);
        }
      } else {
        alertModalRef.value.showAlertModal("경고", "디바이스 설정 불러오기가 실패 했습니다.");
    }
  });		
}

function setDeviceConfig() {
    if (!deviceConfig.value) {
      console.error("setDeviceConfig deviceConfig null");
      return;
    }

    if(!setGuageValue.value.guage) {
      alertModalRef.value.showAlertModal("경고", "임계치 값을 입력해 주세요.");
      return;
    }

    if(setGuageValue.value.guage < 0 || setGuageValue.value.guage > 1000) {
      alertModalRef.value.showAlertModal("경고", "임계치 범위는 0~1000 까지 입니다.");
      return;
    }

    const dConfig = deviceConfig.value.configjson;
    const sConfig  = dConfig?.set_sensor?.[props.setsensor.dfkey]
    
    sConfig.guage = setGuageValue.value.guage
    sConfig.alert = setGuageValue.value.alert
    
    const data = JSON.stringify({ 'operator': "setDeviceConfig", 
        'deviceid' : props.setdevice.deviceid, 
        'config' : deviceConfig.value.configjson, 
        'use' : deviceConfig.value.configuse,
        'alertconfig': deviceConfig.value.alertconfigjson});
   
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/ajax/ajaxcall');
    xhr.setRequestHeader('Content-type', "application/json");
    xhr.send(data);

    xhr.addEventListener('load', function(){
        let result: AjaxResult = JSON.parse(xhr.responseText);
        if(result.err === 0) {
          emit('save')
          emit('close')
        } else {
          console.log("failed! ", result.err);
          alertModalRef.value.showAlertModal("확인", "제어변수 설정이 실패 했습니다." + result.err);
        }
    });
}

const handleClose = () => {
  emit('close')
}

const handleSave = () => {
  setDeviceConfig();
  // emit('close')
}

</script>

<style lang="">
    
</style>